import React from 'react';
import { Navigate } from 'react-router';
import Base from '../../Base';
import SelectAsync from 'react-select/async';

export default class Curriculum extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/curriculum/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        this.httpPost("api/v1/curriculum/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            title: this.state.data.record.title,
            code: this.state.data.record.code,
            description: this.state.data.record.description,
            isActive: this.state.data.record.isActive,
            curriculumLevelId: this.state.data.record.curriculumLevelId,
            curriculumTypeId: this.state.data.record.curriculumTypeId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات شخص" : "افزودن شخص جدید"}
                            </h4>
                        </div>
                        {this.renderBody()}
                    </div>
                </div>
            </div>
        </div>
    }
    renderBody() {
        return [
            <div className="modal-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label className="form-label">عنوان</label>
                                <div className="form-control-wrap">
                                    <input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-1">
                            <div className="form-group">
                                <label className="form-label">کد</label>
                                <div className="form-control-wrap">
                                    <input autocomplete="off" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} onkeypress="return isCharacterKey(event)" type="text" className="form-control input-sm" maxlength="100" />
                                </div>
                            </div>
                        </div><div className="col-sm-3">
                            <div className="form-group">
                                <label className="form-label">نوع</label>
                                <div className="form-control-wrap">
                                <SelectAsync
                                    isClearable={true}
                                    defaultValue={this.state.data.record.curriculumTypeId == null ? null : [{ value: this.state.data.record.curriculumTypeId, label: this.state.data.record.curriculumTypeTitle }]}
                                    isMulti={false}
                                    placeholder="نوع برنامه"
                                    defaultOptions
                                    loadOptions={(inputValue, callback) => this.loadCurriculumTypesOptions(inputValue, callback)}
                                    onChange={e => {
                                        if (e == null) {
                                            this.state.data.record.curriculumTypeId = null;
                                            this.state.data.record.curriculumTypeTitle = '';
                                        }
                                        else {
                                            this.state.data.record.curriculumTypeId = e.value;
                                            this.state.data.record.curriculumTypeTitle = e.label;
                                        }
                                        this.setState({ data: this.state.data });
                                    }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label className="form-label">سطح</label>
                                <div className="form-control-wrap">
                                <SelectAsync
                                    isClearable={true}
                                    defaultValue={this.state.data.record.curriculumLevelId == null ? null : [{ value: this.state.data.record.curriculumLevelId, label: this.state.data.record.curriculumLevelTitle }]}
                                    isMulti={false}
                                    placeholder="سطح برنامه"
                                    defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadCurriculumLevelsOptions(inputValue, callback)}
                                    onChange={e => {
                                        if (e == null) {
                                            this.state.data.record.curriculumLevelId = null;
                                            this.state.data.record.curriculumLevelTitle = '';
                                        }
                                        else {
                                            this.state.data.record.curriculumLevelId = e.value;
                                            this.state.data.record.curriculumLevelTitle = e.label;
                                        }
                                        this.setState({ data: this.state.data });
                                    }}
                                    />
                                </div>
                            </div>
                        </div>   
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label className="form-label">توضیحات</label>
                                <div className="form-control-wrap">
                                    <textarea autocomplete="off" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} type="text" className="form-control input-sm" ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label className="form-label"><input type="checkbox" defaultChecked={this.state.data.record.isActive} onChange={e => this.state.data.record.isActive = e.target.checked} /> فعال است</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div className="modal-footer">
                <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                    <span className="shortcut">F4 - </span> ذخیره
                </button>
            </div>
        ];
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline ? this.renderBody() : this.renderForm()
            ];

        return contents;
    }
}